import { ExpandMore } from '@mui/icons-material';
import { Button, ButtonGroup, Menu, MenuItem, useTheme } from '@mui/material';
import { LoadingButton } from '@prismamedia/one-components';
import React, { FC, useCallback, useState, MouseEvent } from 'react';
import { ArticleState } from '../../pages/ArticleEdit/reducer';
import { SAVE, SAVE_WITHOUT_EDITED } from './constants';
import { useStyles } from './styles';

interface SaveButtonProps {
  disabled?: boolean;
  loading?: boolean;
  onClick?: (forceArticle?: ArticleState, editedAt?: string | null) => void;
}

export const SaveButton: FC<SaveButtonProps> = ({
  disabled,
  loading,
  onClick,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClose = useCallback((): void => {
    setAnchorEl(null);
  }, []);

  const handleBtnClick = useCallback((): void => {
    onClick?.();
  }, [onClick]);

  const handleIconBtnClick = useCallback(
    (event: MouseEvent<HTMLElement>): void => {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    },
    [],
  );

  return (
    <>
      <ButtonGroup
        variant="contained"
        className={classes.buttonGroup}
        disabled={disabled || loading}
      >
        <LoadingButton
          loaderColor={theme.palette.common.white}
          onClick={handleBtnClick}
          data-testid="save-button"
          classes={{ root: classes.button, disabled: classes.buttonDisabled }}
          disabled={disabled}
          loading={loading}
        >
          {SAVE}
        </LoadingButton>
        <Button
          data-testid="save-button-menu"
          onClick={handleIconBtnClick}
          classes={{
            root: classes.menuButton,
            disabled: classes.buttonDisabled,
          }}
          aria-label="Plus d'options de sauvegarde"
        >
          <ExpandMore fontSize="small" />
        </Button>
      </ButtonGroup>
      <Menu
        anchorEl={anchorEl}
        data-testid="statusOverlay"
        open={Boolean(anchorEl)}
        onBlur={handleClose}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem
          onClick={() => {
            onClick?.(undefined, null);
            handleClose();
          }}
        >
          {SAVE_WITHOUT_EDITED}
        </MenuItem>
      </Menu>
    </>
  );
};
